import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation UserLesson_publish($lessonId: ID!) {
    UserLesson_publish(lessonId: $lessonId) {
      status
    }
  }
`;

const UserLessonPublish = async ({ lessonId }) =>
  graphql(mutation, {
    lessonId,
  }).then(
    // eslint-disable-next-line camelcase
    ({ UserLesson_publish }) => UserLesson_publish
  );

export default UserLessonPublish;
